module.exports = __webpack_public_path__ + "img/random2.5cf56847.png";